import React, { useContext, useState} from "react";
import DashboardFiltersContext from "./dashboardFiltersContext";
import { initialState } from "../../reducers/dashboardFiltersReducer";

export const useDashboardFiltersContext = () => useContext(DashboardFiltersContext);

const DashboardFiltersContextState = ({children}) => {

  const [dashboardFilters, setDashboardFilters] = useState(initialState);

  return (
    <DashboardFiltersContext.Provider
      value={{
        dashboardFilters,
        setDashboardFilters
      }}
    >
      {children}
    </DashboardFiltersContext.Provider>
  );
};

export default DashboardFiltersContextState;